import React, { useEffect, useState } from "react";

const Banner = () => {
  const [sliderData, setSliderData] = useState([]);

  useEffect(() => {
    const fetchSlides = async () => {
      try {
        const res = await fetch(
          "https://cms.maitretech.com/seedlingschoolbhopal/items/homeslider?fields=*.*.*"
        );
        const data = await res.json();

        const slides = data?.data
          ?.map((item) => {
            const imageUrl = item?.image?.data?.full_url?.replace(
              "http://",
              "https://"
            );
            return {
              id: item.id,
              image: imageUrl,
            };
          })
          .filter((slide) => slide.image);

        setSliderData(slides || []);
      } catch (err) {
        console.error("Failed to fetch slider data:", err);
      }
    };

    fetchSlides();
  }, []);

  return (
    <div
      id="carouselExampleInterval"
      className="carousel slide"
      data-bs-ride="carousel"
    >
      <div className="carousel-inner jaimataran">
        {sliderData.map((slide, index) => (
          <div
            key={slide.id}
            className={`carousel-item ${index === 0 ? "active" : ""}`}
            data-bs-interval="4000"
          >
            <img src={slide.image} className="d-block w-100" alt={`Slide ${index + 1}`} />
          </div>
        ))}
      </div>

      <button
        className="carousel-control-prev"
        type="button"
        data-bs-target="#carouselExampleInterval"
        data-bs-slide="prev"
      >
        <span className="carousel-control-prev-icon" aria-hidden="true" />
        <span className="visually-hidden">Previous</span>
      </button>

      <button
        className="carousel-control-next"
        type="button"
        data-bs-target="#carouselExampleInterval"
        data-bs-slide="next"
      >
        <span className="carousel-control-next-icon" aria-hidden="true" />
        <span className="visually-hidden">Next</span>
      </button>
    </div>
  );
};

export default Banner;
